(() => {
  const selector = '.ff-gallery--plume-dame';

  const bindGallery = (root) => {
    if (!root || root.dataset.ffGalleryCounterBound === 'true') return;

    const gallery = root.querySelector('[data-swiper-role="main-product-gallery"]');
    const current = root.querySelector('[data-gallery-current]');
    const thumbnails = [...root.querySelectorAll('[data-ff-gallery-thumb]')];
    if (!gallery || !current) return;

    root.dataset.ffGalleryCounterBound = 'true';

    const update = (swiper) => {
      const instance = swiper || gallery.swiper;
      const index = Number.isFinite(instance?.realIndex)
        ? instance.realIndex
        : Number.isFinite(instance?.activeIndex)
          ? instance.activeIndex
          : 0;
      current.textContent = String(index + 1);
      thumbnails.forEach((thumbnail, thumbnailIndex) => {
        const active = thumbnailIndex === index;
        thumbnail.classList.toggle('is-active', active);
        thumbnail.setAttribute('aria-selected', String(active));
      });
    };

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        const index = Number.parseInt(thumbnail.dataset.ffGalleryThumb, 10);
        if (!Number.isFinite(index) || !gallery.swiper) return;
        gallery.swiper.slideTo(index);
        update(gallery.swiper);
      });
    });

    gallery.addEventListener('swiperinit', (event) => update(event.detail?.[0]));
    gallery.addEventListener('swiperslidechange', (event) => update(event.detail?.[0]));

    if (gallery.swiper) {
      update(gallery.swiper);
      gallery.swiper.on?.('slideChange', () => update(gallery.swiper));
    }
  };

  const init = (scope = document) => {
    scope.querySelectorAll(selector).forEach(bindGallery);
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

